module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "epi"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "epslf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _vm._v("And we know, when Moses was told,")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("in the way he was told,")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("“Take off your shoes!” He grew pale from that simple")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("reminder of fire in the dusty earth.")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("He never recovered")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("his complicated way of loving again")]), _vm._v(" "), _c('p', {
    staticClass: "epslf"
  }, [_vm._v("and was free to love in the same way")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("he felt the fire licking at his heels loved him.")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—David Whyte, “Fire in the Earth”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c35a94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rbgfeder0007.vue
// module id = 72
// module chunks = 0